import { useNavigate } from "react-router-dom";

const Titlebtn = ({ label = "Add", url = "/" , isIcon = true}) => {
  const navigate = useNavigate();

  return (
    <button
      onClick={() => navigate(url)}
      className=" w-fit  px-4 h-[50px] flex items-center justify-center gap-2 bg-primary text-white rounded-[10px] hover:bg-primary/90 transition-all duration-200"
    >
     {isIcon && <i className="uil uil-plus text-lg"></i>}
      <span className="font-medium">{label}</span>
    </button>
  );
};

export default Titlebtn;